import { EuiIcon, EuiListGroup, EuiListGroupItem, EuiTextColor } from "@elastic/eui";
import React from "react";
import { FormattedMessage } from "react-intl";
import TripSection from "../shared/TripSection";

const generateListItemIcon = (flag) => (
    <EuiIcon
        type={flag ? "check" : "alert"}
        color={flag ? "success" : "danger"}
    />
);

const generateListItemText = (flag, text) => (
    <EuiTextColor color={flag ? "secondary" : "danger"}>{text}</EuiTextColor>
);

const generateListItem = ({ label, icon }, i) => (
    <EuiListGroupItem
        key={i}
        onClick={() => {}}
        label={label}
        icon={icon}
    />
);

export default function TripCheckList({ checkList }) {
    const listOptions = [
        {
            onClick: () => {},
            label: generateListItemText(
                checkList.isDropoffEntered,
                <FormattedMessage id="trip.checklist-dropoff-details" />
            ),
            icon: generateListItemIcon(checkList.isDropoffEntered),
        },
        {
            onClick: () => {},
            label: generateListItemText(
                checkList.isDriverAssigned,
                <FormattedMessage id="trip.checklist-driver-assigned" />
            ),
            icon: generateListItemIcon(checkList.isDriverAssigned),
        },
        {
            onClick: () => {},
            label: generateListItemText(
                checkList.isTruckAssigned,
                <FormattedMessage id="trip.checklist-truck-assigned" />
            ),
            icon: generateListItemIcon(checkList.isTruckAssigned),
        },
        {
            onClick: () => {},
            label: generateListItemText(
                checkList.isPickupDocumentsUploaded,
                <FormattedMessage id="trip.checklist-pickup-doc" />
            ),
            icon: generateListItemIcon(checkList.isPickupDocumentsUploaded),
        },
        {
            onClick: () => {},
            label: generateListItemText(
                checkList.isDropoffDocumentsUploaded,
                <FormattedMessage id="trip.checklist-dropoff-doc" />
            ),
            icon: generateListItemIcon(checkList.isDropoffDocumentsUploaded),
        },
    ];

    return (
        <TripSection
            headerTitle={<FormattedMessage id="trip.checklist-section-title" />}
            headerIconType="editorUnorderedList"
            size="sm"
            isIconSection
        >
            <div className="checklist-wrapper">
                <EuiListGroup
                    flush
                    wrapText
                >
                    {listOptions.map(generateListItem)}
                </EuiListGroup>
            </div>
        </TripSection>
    );
}
